import { Box, Typography } from '@mui/material';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { LanguageService } from '../../../../services/languageService';

const LanguageToggle = () => {
	const languageService = new LanguageService();
	const toggledLanguage = languageService.getToggledLanguage();

	const onToggleLanguage = () => {
		languageService.onToggleLanguage();
	};

	return (
		<Box
			onClick={onToggleLanguage}
			className="flex items-center gap-1.5 border border-gray-300 rounded-full px-3 py-1.5 cursor-pointer hover:bg-gray-50 transition-colors">
			<LanguageOutlinedIcon className="!text-[20px] !text-gray-600" />
			<Typography
				variant="subtitle2"
				className="!text-gray-700 !text-sm !font-medium">
				{toggledLanguage?.name}
			</Typography>
		</Box>
	);
};

export default LanguageToggle;
